import TextWithPlus from './TextWithPlus'

export default TextWithPlus
